import { sdkFactory as wixForumV1Category_sdkFactory_categories } from './src/forum-v1-category.frontend';
import { sdkFactory as wixForumV1Post_sdkFactory_posts } from './src/forum-v1-post.frontend';
export function sdkFactory(args) {
    return {
        categories: wixForumV1Category_sdkFactory_categories(args),
        posts: wixForumV1Post_sdkFactory_posts(args),
    };
}
//# sourceMappingURL=index.frontend.js.map